module.exports = "<div>\r\n  <h1 style=\"font-weight:bold;color:dimgray;margin-left:auto;margin-right:auto;margin-top:264px;;margin-bottom:auto;width:400px\">ADMIN VIEW</h1>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/views/portal-admin-view/portal-admin.component.html
// module id = ./src/app/views/portal-admin-view/portal-admin.component.html
// module chunks = main